import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router";
import { useAuth } from "@/features/auth";
import { getSelectedContentByPath } from "@/shared/utils";
import { DefaultLayout } from "./DefaultLayout";

const publicRoutes = ["/login", "/forgot-pw", "/init-pw", "/reset-pw"];

export const RootLayoutClient = () => {
	const { isAuthenticated } = useAuth();
	const navigate = useNavigate();
	const location = useLocation();
	const pathname = location.pathname;
	const selectedContent = getSelectedContentByPath(pathname);

	useEffect(() => {
		if (isAuthenticated === false && !publicRoutes.includes(pathname)) {
			navigate("/login");
		}
	}, [isAuthenticated, pathname, navigate]);

	if (publicRoutes.includes(pathname)) {
		return <Outlet />;
	}

	return (
		<DefaultLayout selectedContent={selectedContent}>
			<Outlet />
		</DefaultLayout>
	);
};
